import { useNotifyStore } from '@/stores'
import { actingContextMessageKey } from './useAxiosError'
import { uuid } from './uuid'

type Translate = (key: string, params?: Record<string, unknown>) => string

type RefusedRecord = { type: string; name: string; content: string }

type BulkDnsRefusals = {
  note: (error: unknown, record: RefusedRecord) => void
  notify: (t: Translate) => void
}

/**
 * Collects the records of a bulk DNS run that an acting-context fence refused,
 * such as MX on a domain carrying a login address, so the run names them with
 * the reason rather than counting them among plain failures.
 */
export function bulkDnsRefusals(): BulkDnsRefusals {
  const refused = new Map<string, string[]>()
  return {
    note(error, record) {
      const key = actingContextMessageKey(error)
      if (!key) return
      const label = `${record.type} ${record.name || '@'} ${record.content}`.trim()
      refused.set(key, [...(refused.get(key) ?? []), label])
    },
    /** One error notice per fence that refused anything: its reason and the records. */
    notify(t) {
      const notifyStore = useNotifyStore()
      for (const [key, records] of refused) {
        const message = `${t(key)} ${t('dashboard.domains.dns.refusedRecords', { records: records.join(', ') })}`
        notifyStore.createNotify({ id: uuid('v4'), alertType: 'error', title: t('common.error'), message })
      }
    }
  }
}
